export const calendarStrings = {
    lastDay: '[Hier à] HH:mm',
    sameDay: '[Aujourd\'hui à] HH:mm',
    nextDay: '[Demain] HH:mm',
    lastWeek: 'dddd [dernier] [à] HH:mm',
    nextWeek: 'dddd HH:mm',
    sameElse: 'L'
};
